import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import { FilledButton } from 'shared-components/Buttons/FilledButton';
import { OutlineButton } from 'shared-components/Buttons/Outline';
import { ErrorWrapper } from 'shared-components/ErrorWrapper';
import { FormWrapper } from 'components/common/FormWrapper';
import { FormRow } from 'components/common/FormWrapper/styles';
import PKDHeader from 'components/Home/Header';
import { TextInput } from 'components/PKDTextField';
import ProfileImage from 'images/SignIn/sign-in.png';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'utils/isMobile';
import { emailRegExp } from 'utils/regexp';
import { getStyles } from './styles';

const initialState = {
  firstname       : '',
  lastname        : '',
  email           : '',
  confirmEmail    : '',
  password        : '',
  confirmPassword : '',
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = getStyles(theme);
  const [state, setState] = useState(initialState);
  const pkdUser = state;
  const defaultValues = { email: pkdUser.email || '' };
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues,
  });

  const onSave = (data) => {
    // TO BE IMPLEMENTED
  };

  const goBack = (
    <OutlineButton
      width='224px'
      height='40px'
      fontFamily='Montserrat'
      color={theme.palette.primary.blue1}
      borderColor={theme.palette.primary.blue1}
      text='Go back'
      onClickHandler={() => navigate('/home')}
    />
  );

  const continueBtn = (
    <FilledButton
      width='224px'
      height='40px'
      fontFamily='Montserrat'
      background={theme.palette.primary.blue1}
      text='Continue'
      disabled={!!errors?.email?.message}
      onClick={handleSubmit(onSave)}>
      Continue
    </FilledButton>
  );
  const buttons = isMobile()
    ? (
      <Box
        sx={styles.btnContainerMobile}>
        <Box
          sx={{ display: 'flex' }}>{continueBtn}</Box>
        <Box
          sx={{ marginTop: '10px', display: 'flex' }}>{goBack}</Box>
      </Box>
    )
    : (
      <Box
        sx={styles.btnContainer}>
        {goBack}
        <Box
          sx={{ marginLeft: '26px' }}>{continueBtn}</Box>
      </Box>
    );

  return (
    <Box>
      <PKDHeader />
      <Box
        sx={styles.mainContainer}>
        <FormWrapper
          image={ProfileImage}>
          <Box
            sx={styles.rightPanel}>
            <Stack>
              <Box
                sx={isMobile() ? styles.headers : {}}>
                <Box
                  sx={isMobile() ? styles.titleMobile : styles.title}>
                  Recover password
                </Box>
                <Box
                  sx={styles.titleText}>
                  Type your email and we will send a reset link.
                </Box>
              </Box>

              <Box>
                <FormRow>
                  <Box
                    sx={styles.field}>
                    <Controller
                      name='email'
                      control={control}
                      rules={{
                        required : {
                          value   : true,
                          message : 'Please enter an email address',
                        },
                        pattern : {
                          value   : emailRegExp,
                          message : 'Please enter a valid email address',
                        },
                      }}
                      render={({ field }) => (
                        <ErrorWrapper>
                          <TextInput
                            label='Email'
                            size='small'
                            fullWidth
                            error={!!errors.email}
                            haserrors={
                              !!errors.email && {
                                type    : 'custom',
                                message : errors.email.message,
                              }
                            }
                            {...field}
                          />
                        </ErrorWrapper>
                      )}
                    />
                  </Box>
                </FormRow>
              </Box>
              <Box
                sx={{ ...styles.footerContainer, marginTop: '100px' }}>
                {buttons}
              </Box>
            </Stack>
          </Box>
        </FormWrapper>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
